import React, { ReactElement } from 'react';
import { PlusCircleOutlined } from '@severalnines/frontend_hub/libs/icons';

function CcxIconPlusCircleOutlined(): ReactElement {
    return <PlusCircleOutlined data-testid="CcxIconPlusCircleOutlined" />;
}

export default CcxIconPlusCircleOutlined;
